export default __webpack_public_path__ + "static/media/upload_icon_green.400cd355.svg";